/* lua.js generated code 0.3.0 */

require("clover/panel/base/BasePanel")
require("clover/panel/component/common/UIGroupButton")
require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
let Panel = xClass("CommonQuesPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/common_ques_panel.csb")
})
let PanelEvent = {
    "Close" : "STARRANKINFOPANELEVENT.CLOSE",
    "Sure" : "STARRANKINFOPANELEVENT.SURE"
}

let quickBuildToastFunc = function (text, callback) {
    return function () {
        Toast.make(text, 1, () => {
            callback && callback()
        })
    }
}
Panel.show = function (title, content, sureBtnText, useRichText, onSuccess, onFail, onCancel) {
    function success() {
        let panel = Panel.create(title, content, sureBtnText, useRichText)
        if (onSuccess) {
            onSuccess(panel)
        }else {
            panel.popup(true)
        }
    }
    onFail = onFail || quickBuildToastFunc(getText("error.tip.load_res_error"))
    onCancel = onCancel || quickBuildToastFunc(getText("error.tip.load_canceled"))
    preloadWithLoading(["packed/CommonQuesPanelRes.pack"], success, onFail, onCancel)
}
Panel.prototype.ctor = function (title, content, sureBtnText, useRichText) {
    let self = this
    BasePanel.prototype.ctor.call(self)
    self.title = title
    self.content = content
    self.sureBtnText = sureBtnText
    self.useRichText = useRichText
    self.buildUI()
}
Panel.prototype.buildUI = function () {
    let self = this
    let bg = self.getChildByName("bg")
    let bgSize = bg.getContentSize()
    let close = UIButton.create(self.getChildByName("close"))
    PushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function (evt) {
        self.onCloseBtnClicked(evt)
    })
    let btn = UIGLabelButton.create(self.getChildByName("btn"))
    btn.setString(self.sureBtnText || getText("clover.text.228"))
    PushBounceAnim.create(btn)
    btn.on(UIButtonEvent.Click, function (evt) {
        self.onSureBtnClicked(evt)
    })
    let title = self.getChildByName("title")
    title.setString(self.title)
    title.setPositionX((bgSize.width - title.getContentSize().width) / 2)
    let text = self.getChildByName("text")
    let size = text.getContentSize()

    let newSize = null
    if (self.useRichText) {
        let GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
        let color = text.getTextColor()
        let newText = GameGuideAnims.createMixedText(self.content, 25, color, size.width, "left")
        newSize = HeDisplayUtil.getNodeGroupBounds(newText, null)
        self.addChild(newText, 1, "text")
        newText.setPosition(text.getPosition())
        text.removeFromParent(true)
    }else {
        text.getVirtualRenderer().setDimensions(size.width, 0)
        text.setString(self.content)
        newSize = text.getVirtualRendererSize()
    }
    // csb 里面设置过宽高, 如果这里不重新设置会导致部分超出的部分不显示
    text.setContentSize(newSize)
    btn.setPositionY(btn.getPositionY() + size.height - newSize.height - 20)
    let newBgSize = cc.size(bgSize.width, bgSize.height - size.height + newSize.height + 20)
    bg.setContentSize(newBgSize)
    self.setContentSize(newBgSize)
    // self.setPosition(bg.getContentSize())
}
Panel.prototype.onCloseBtnClicked = function () {
    let self = this
    self.dispatchEvent({"name" : PanelEvent.Close})
}
Panel.prototype.onSureBtnClicked = function () {
    let self = this
    self.dispatchEvent({"name" : PanelEvent.Close})
}
Panel.prototype.onKeyBackClicked = function () {
    let self = this
    self.dispatchEvent({"name" : PanelEvent.Close})
}
Panel.prototype.onCleanup = function() {
    ResManager.release(["packed/CommonQuesPanelRes.pack"]);
}

module.exports = [Panel, PanelEvent]
